import React from "react";
import "./Account_tab_card.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

function Account_tab_card({
  heading_title,
  icon,
  card_title,
  link_text,
  link,
}) {
  return (
    <>
      <section className="Account_tab_card">
        <div className="card_heading_holder">
          <h2>{heading_title}</h2>
          <div className="heading_icon_holder">
            <div className="icon_holder">
              <FontAwesomeIcon icon={icon} className="card_icon" />
            </div>
          </div>
        </div>
        <div className="card_content_holder">
          <div className="text_hodler">
            <h3>{card_title}</h3>
            <Link to={link}>
              <p>{link_text}</p>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default Account_tab_card;
  